/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FileDownloadResponseDto = {
  /**
   * File Download Link
   */
  link?: string;
  /**
   * File Download Link HTTP Method
   */
  method?: FileDownloadResponseDto.method;
  /**
   * File Download Link Expiration Date
   */
  expiresAt?: string;
};
export namespace FileDownloadResponseDto {
  /**
   * File Download Link HTTP Method
   */
  export enum method {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    DELETE = 'DELETE',
    HEAD = 'HEAD',
    PATCH = 'PATCH',
    OPTIONS = 'OPTIONS',
  }
}

